<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['common.type']">
          <a-radio-group v-model="model.areaLevel" >
            <a-radio value="0" disabled>
              {{language['factory']}}
            </a-radio>
            <a-radio value="1" disabled>
              {{language['area']}}
            </a-radio>
            <a-radio value="2" disabled>
              {{language['danger.build']}}
            </a-radio>
            <a-radio value="3" disabled>
              {{language['danger.floor']}}
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="model.areaLevel==0" :label="language['factory']"  :labelCol="labelCol" :wrapperCol="wrapperCol" id="factoryId" prop="factoryId">
          <a-select
            v-model="model.factoryId"
            :options="factoryOptions"
            @change="factoryChange"
            :placeholder="language['common.pleaseInput']+language['factory']" >
          </a-select>
        </a-form-model-item>
        <a-form-model-item v-if="model.areaLevel!=0" :label="language['common.name']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="areaName">
          <a-input v-model="model.areaName" :placeholder="language['common.pleaseInput']+language['common.name']" style="width: 85%"></a-input>
          <a-button @click="languageModelOpen('CstBdArea','areaName',areaNameLanguages)" type="primary"  style="left: 3%" >{{language['common.language']}}</a-button>
        </a-form-model-item>

        <a-form-model-item :label="language['common.code']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="areaCode" :disabled="model.areaLevel==0">
          <a-input v-model="model.areaCode" :placeholder="language['common.pleaseInput']+language['common.code']" ></a-input>
        </a-form-model-item>

        <a-form-model-item v-if="model.areaLevel!=0" :labelCol="labelCol" :wrapperCol="wrapperCol" :label="language['upperFirst']" hasFeedback>
          <a-tree-select
            style="width:100%"
            :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
            :treeData="areaTree"
            v-model="model.parentId"
            :placeholder="language['column.pleaseChoose']"
            disabled>
          </a-tree-select>
        </a-form-model-item>

          <a-form-model-item :label="language['system.centerLongitude']" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="model.areaLevel!=0">
            <a-input v-model="model.longitude" :placeholder="language['common.pleaseInput']+language['system.centerLongitude']"  ></a-input>
          </a-form-model-item>
          <a-form-model-item :label="language['system.centerLatitude']" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="model.areaLevel!=0">
            <a-input v-model="model.latitude" :placeholder="language['common.pleaseInput']+language['system.centerLatitude']"  ></a-input>
          </a-form-model-item>
          <a-form-model-item :label="language['system.altitude']" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="model.areaLevel!=0">
            <a-input v-model="model.altitude" :placeholder="language['common.pleaseInput']+language['system.altitude']"  ></a-input>
          </a-form-model-item>
        <a-form-model-item :label="language['system.area.coordinates']" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="model.areaLevel!=0">
          <a-input v-model="model.coordinatesX" style="width: 30%"></a-input>
          <a-input v-model="model.coordinatesY" style="width: 30%;left: 5%"></a-input>
          <a-input v-model="model.coordinatesZ" style="width: 30%;left: 10%"></a-input>
        </a-form-model-item>
          <a-form-model-item :label="language['system.isVirtual']" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="model.areaLevel!=0">
            <a-radio-group v-model="model.virtual" >
              <a-radio value="1" >
                {{language['common.yes']}}
              </a-radio>
              <a-radio value="0" >
                {{language['common.no']}}
              </a-radio>
            </a-radio-group>
          </a-form-model-item>

        <a-form-model-item :label="language['basedata.remark']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
          <a-input v-model="model.remark" :placeholder="language['common.pleaseInput']+language['basedata.remark']" ></a-input>
        </a-form-model-item>

        <a-tab-pane :tab="language['selfCheck.ref.file']" :key="refKeys[0]" :forceRender="true">
          <j-editable-table
            :dragSort="true"
            :ref="refKeys[0]"
            :loading="pointListTable.loading"
            :columns="pointListTable.columns"
            :dataSource="pointListTable.dataSource"
            :maxHeight="300"
            :maxNumber="10000"
            :disabled="disableSubmit?disableSubmit:formDisabled"
            :rowNumber="true"
            :is-show-download-button="false"
            :rowSelection="true"
            :actionButton="true"/>
        </a-tab-pane>

      </a-form-model>
    </a-spin>
    <language-model ref="languageModel" @ok="languageOk"></language-model>
  </j-modal>
</template>

<script>

  import { httpAction, getAction,postAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { queryAreaIdTree } from '@/api/api'
  import LanguageModel from "@/components/LanguageModel"
  import { FormTypes,getRefPromise,VALIDATE_NO_PASSED,validateFormModelAndTables } from '@/utils/JEditableTableUtil'
  import { JEditableTableModelMixin } from '@/mixins/JEditableTableModelMixin'

  export default {
    name: "CstBdAreaModal",
    mixins: [JEditableTableModelMixin],
    components: {
      LanguageModel
    },
    data () {
      return {
        title:"操作",
        width:800,
        visible: false,
        model:{
          areaLevel: "0"
         },
        records:[],
        factoryOptions: [],
        areaTree:[],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        url: {
          add: "/sys/area/add",
          edit: "/sys/area/edit",
          queryFactoryList: '/sys/epFactory/list',
          pointList: '/sys/point/queryPointListByAreaId',
        },
        expandedRowKeys:[],
        pidField:"pid",
        areaNameLanguages:[],

        refKeys: ['pointList', ],
        tableKeys:['pointList', ],
        activeKey: 'pointList',
        // 相关附件
        pointListTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: this.$store.getters.language['system.placeOrLocation'],
              key: 'pointName',
              type: FormTypes.input,
              token:true,
              responseName:"message",
              width:"200px",
              placeholder: this.$store.getters.language['common.pleaseInput']+'${title}',
              defaultValue:'',
              validateRules: [{ }],
            },
            {
              title: this.$store.getters.language['system.longitude'],
              key: 'longitude',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$store.getters.language['common.pleaseInput']+'${title}',
              defaultValue:'',
              validateRules: [{
                pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,6})?$/, // 正则
                message: '${title}'+this.$store.getters.language['keep.up.two.decimal.places']
              }]
            },
            {
              title: this.$store.getters.language['system.latitude'],
              key: 'latitude',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$store.getters.language['common.pleaseInput']+'${title}',
              defaultValue:'',
              validateRules: [{
                pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,6})?$/, // 正则
                message: '${title}'+this.$store.getters.language['keep.up.two.decimal.places']
              }]
            },
          ]
        },
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      validatorRules() {
        if (this.language) {
          return {
            areaName: [
              { required: true, message: this.language['common.pleaseInput']+this.language['common.name']},
            ],
            areaCode: [
              { required: true, message: this.language['common.pleaseInput']+this.language['common.code']},
            ],

          }
        }
      },
    },
    created () {
       this.initFactoryList();
    },
    methods: {
      languageModelOpen(dataTable,dataColumn,languagelist){
        this.$refs.languageModel.edit("platform",dataTable,dataColumn,this.model.id,languagelist,this.disableSubmit);
      },
      languageOk(map){
        if(map&&map.dataColumn == 'areaName'){
          this.areaNameLanguages = map.languagelist;
        }
      },
      initLanguagetemp(dataTable,dataColumn,dataId) {
        getAction("/sys/syslanguagedata/querylistby", {
          applicationCode: "platform",
          dataTable: dataTable,
          dataColumn: dataColumn,
          dataId: dataId
        }).then((res) => {
          if (res.success) {
            this.areaNameLanguages = res.result;
          }
        })
      },
      add (record) {
        this.model ={
          areaLevel: "0"
        }
        this.visible = true;
        this.loadTreeData();
        if(record){
          this.model.parentId = record.id!=null?record.id.toString():0;
          if(this.model.parentId===0){
            this.model.areaLevel="0"
          }else{
            const areaLevel= 1+Number(record.areaLevel)
            this.model.areaLevel = areaLevel.toString()
          }
        }
        this.initLanguagetemp('CstBdArea','areaName','')
        this.pointListTable = {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: this.$store.getters.language['system.placeOrLocation'],
              key: 'pointName',
              type: FormTypes.input,
              token:true,
              responseName:"message",
              width:"200px",
              placeholder: this.$store.getters.language['common.pleaseInput']+'${title}',
              defaultValue:'',
              validateRules: [{ }],
            },
            {
              title: this.$store.getters.language['system.longitude'],
              key: 'longitude',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$store.getters.language['common.pleaseInput']+'${title}',
              defaultValue:'',
              validateRules: [{
                pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,6})?$/, // 正则
                message: '${title}'+this.$store.getters.language['keep.up.two.decimal.places']
              }]
            },
            {
              title: this.$store.getters.language['system.latitude'],
              key: 'latitude',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$store.getters.language['common.pleaseInput']+'${title}',
              defaultValue:'',
              validateRules: [{
                pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,6})?$/, // 正则
                message: '${title}'+this.$store.getters.language['keep.up.two.decimal.places']
              }]
            },
          ]
        };
      },
      edit (record) {
        this.visible = true;
        this.loadTreeData();
        this.model ={
          areaLevel: "0"
        }
        this.model = Object.assign({}, record);
        this.initLanguagetemp('CstBdArea','areaName',record.id)
        this.$nextTick(() => {
          // 加载子表数据
          if (this.model.id) {
            let params = { id: this.model.id }
            this.requestSubTableData(this.url.pointList, params, this.pointListTable)
          }
        })
      },

      loadTreeData(){
        var that = this;
        queryAreaIdTree().then((res)=>{
          if(res.success){
            that.areaTree = [];
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i];
              that.areaTree.push(temp);
            }
          }

        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.$refs.form.clearValidate()
      },
      handleOk () {
        const that = this;
        this.$refs.form.validate((valid,data) => {
          if (valid) {


            /*let str = this.Http_msgContent_toStr()
            that.model.msgContent = str;*/
            /** 触发表单验证 */
            this.getAllTable().then(tables => {
              return validateFormModelAndTables(this.$refs.form,this.model, tables)
            }).then(allValues => {
              /** 一次性验证一对一的所有子表 */
              return this.validateSubForm(allValues)
            }).then(allValues => {
              let formData = this.classifyIntoFormData(allValues)
              console.log("this.formData", formData)
              // 发起请求
              that.send(formData);
            })
          }
        })
      },
      send(formData){
        const that = this;

        // 触发表单验证
        that.confirmLoading = true;
        let httpurl = '';
        let method = '';
        if(!this.model.id){
          httpurl+=this.url.add;
          method = 'post';
        }else{
          httpurl+=this.url.edit;
          method = 'put';
        }
        if(this.model.id && this.model.id === this.model[this.pidField]){
          that.$message.warning("父级节点不能选择自己");
          that.confirmLoading = false;
          return;
        }
        let pointList = formData.pointList!= null?formData.pointList:[];
        this.model.pointList = pointList;

        httpAction(httpurl,this.model,method).then((res)=>{
          if(res.success){
            this.areaNameLanguages.forEach(item=>{
              if(!item.dataId){
                item.dataId = res.result.id;
              }
            })
            httpAction("/sys/syslanguagedata/saveSysLanguageDataList",this.areaNameLanguages,"post").then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.confirmLoading = false;
                that.close();
                that.$emit('ok');
              }
            })
          }else{
            that.$message.warning(res.message);
            that.confirmLoading = false;
            that.close();
          }
        }).finally(() => {
          // that.close();
        })

      },
      handleOkOld () {
        const that = this;
        // 触发表单验证
       this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
             if(this.model.id && this.model.id === this.model[this.pidField]){
              that.$message.warning("父级节点不能选择自己");
              that.confirmLoading = false;
              return;
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                this.areaNameLanguages.forEach(item=>{
                  if(!item.dataId){
                    item.dataId = res.result.id;
                  }
                })
                httpAction("/sys/syslanguagedata/saveSysLanguageDataList",this.areaNameLanguages,"post").then((res)=>{
                  if(res.success){
                    that.$message.success(res.message);
                    that.confirmLoading = false;
                    that.close();
                    that.$emit('ok');
                  }
                })
              }else{
                that.$message.warning(res.message);
                that.confirmLoading = false;
                that.close();
              }
            }).finally(() => {
              // that.close();
            })
          }else{
             return false
          }
        })
      },
      handleCancel () {
        this.pointListTable = {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: this.$store.getters.language['system.placeOrLocation'],
              key: 'pointName',
              type: FormTypes.input,
              token: true,
              responseName: "message",
              width: "200px",
              placeholder: this.$store.getters.language['common.pleaseInput'] + '${title}',
              defaultValue: '',
              validateRules: [{}],
            },
            {
              title: this.$store.getters.language['system.longitude'],
              key: 'longitude',
              type: FormTypes.input,
              width: "200px",
              placeholder: this.$store.getters.language['common.pleaseInput'] + '${title}',
              defaultValue: '',
              validateRules: [{
                pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,6})?$/, // 正则
                message: '${title}' + this.$store.getters.language['keep.up.two.decimal.places']
              }]
            },
            {
              title: this.$store.getters.language['system.latitude'],
              key: 'latitude',
              type: FormTypes.input,
              width: "200px",
              placeholder: this.$store.getters.language['common.pleaseInput'] + '${title}',
              defaultValue: '',
              validateRules: [{
                pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,6})?$/, // 正则
                message: '${title}' + this.$store.getters.language['keep.up.two.decimal.places']
              }]
            },
          ]
        };
        this.close();
      },
      submitSuccess(formData,flag){
        if(!formData.id){
          let treeData = this.$refs.treeSelect.getCurrTreeData()
          this.expandedRowKeys=[]
          this.getExpandKeysByPid(formData[this.pidField],treeData,treeData)
          this.$emit('ok',formData,this.expandedRowKeys.reverse());
        }else{
          this.$emit('ok',formData,flag);
        }
      },
      getExpandKeysByPid(pid,arr,all){
        if(pid && arr && arr.length>0){
          for(let i=0;i<arr.length;i++){
            if(arr[i].key==pid){
              this.expandedRowKeys.push(arr[i].key)
              this.getExpandKeysByPid(arr[i]['parentId'],all,all)
            }else{
              this.getExpandKeysByPid(pid,arr[i].children,all)
            }
          }
        }
      },

      //
      factoryChange(val)
      {
        this.records.forEach((vm)=>{

          if(vm.id==val){
            this.model.areaCode = vm.factoryCode;
            this.model.areaName = vm.factoryName;
          }
        })


      },

      //初始化厂区字典
      initFactoryList(){
		  let para={pageNo:1,pageSize:1000};
        getAction(this.url.queryFactoryList,para).then(res=>{
          if(res.success){
            this.records = res.result.records;
            this.factoryOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.factoryName, value: item.id+""}
              return c;
            })
          }
        })
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
          pointList: allValues.tablesValue[0].values
        }
      },
    }
  }
</script>